import { getCurrentCulture } from '../utilities/Localization'
import { setupLoadingButtons } from '@eurotunnel-pax/leshuttle.ui/src/scripts/components/patterns/loading-button'

export function injectSalesHorizonForm (formData, target, modalInstance) {
  if (!formData || !target) {
    return
  }

  let requestUri = `/api2/sales-horizon-form?embark=${formData.embark}&disembark=${formData.disembark}&departDate=${getFormattedDate(formData.outboundDate)}`

  if (!formData.oneWay) {
    requestUri += `&returnDate=${getFormattedDate(formData.returnDate)}`
  }

  fetch(requestUri, {
    method: 'GET',
    headers: {
      'Accept-Language': getCurrentCulture()
    }
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error('Failed to get sales horizon form')
      }
      return res.text()
    })
    .then(html => {
      if (!html) {
        throw new Error('Failed to get sales horizon form - form HTML was null')
      }
      handleFormInjection(html, target, modalInstance)
    })
    .catch(() => {
      console.log('An unexpected error occurred whilst loading the sales horizon form.')
    })
}

function handleFormInjection (html, target, modalInstance) {
  const container = document.querySelector(target)
  if (!container) {
    return
  }
  container.outerHTML = html

  const form = document.getElementById('salesHorizonForm')

  if (!form) {
    console.log('Cannot setup sales horizon form - form DOM element was null')
  }

  // Binds form validation
  document.dispatchEvent(new CustomEvent('form-updated'), { bubbles: true })

  // Re-init dependent controls
  window.setupSelects(form)
  modalInstance.setupEvents()
  setupLoadingButtons()

  // Handle loading button state
  form.addEventListener('submit', function () {
    form.validator.validateForm().then(function (formData) {
      const submitBtn = form.querySelector('button[type="submit"]')
      if (submitBtn && typeof (submitBtn.loadingButtonInstance) !== 'undefined') {
        submitBtn.loadingButtonInstance.toggle()
      }
    }).catch(function (errors, fields) {
    })
  })
}

function getFormattedDate (urlDate) {
  if (!urlDate) {
    return null
  }

  const date = new Date(urlDate)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return '' + year + '-' + month + '-' + day
}
